import {
  FIND_PRODUCTS_BY_CATEGORY_REQUEST,
  FIND_PRODUCTS_BY_CATEGORY_SUCCESS,
  FIND_PRODUCTS_BY_CATEGORY_FAILURE,
  FIND_PRODUCT_BY_ID_REQUEST,
  FIND_PRODUCT_BY_ID_SUCCESS,
  FIND_PRODUCT_BY_ID_FAILURE,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_FAILURE,
  DELETE_PRODUCT_SUCCESS,
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_FAILURE,
  GET_SIMILAR_PRODUCTS_REQUEST,
  GET_SIMILAR_PRODUCTS_SUCCESS,
  GET_SIMILAR_PRODUCTS_FAILURE,
  GET_COMPLEMENTARY_PRODUCTS_REQUEST,
  GET_COMPLEMENTARY_PRODUCTS_SUCCESS,
  GET_COMPLEMENTARY_PRODUCTS_FAILURE,
  GET_COLOR_VARIANTS_REQUEST,
  GET_COLOR_VARIANTS_SUCCESS,
  GET_COLOR_VARIANTS_FAILURE,
} from "./ActionType";

const initialState = {
  products: [],
  product: null,
  searchedProducts: [],
  similarProducts: [],
  complementaryProducts: [],
  colorVariants: [],
  loading: false,
  error: null,
  deleteProduct:null,
};

const customerProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case FIND_PRODUCTS_BY_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null,products:[] };
    case FIND_PRODUCTS_BY_CATEGORY_SUCCESS:
      return { ...state, products: action.payload, loading: false };
    case FIND_PRODUCTS_BY_CATEGORY_FAILURE:
      return { ...state, loading: false, products:[], error: action.payload };
    case FIND_PRODUCT_BY_ID_REQUEST:
      return { ...state, loading: true, error: null };
    case FIND_PRODUCT_BY_ID_SUCCESS:
      return { ...state, product: action.payload, loading: false };
    case FIND_PRODUCT_BY_ID_FAILURE:
      return { ...state, loading: false, error: action.payload };
      case CREATE_PRODUCT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case CREATE_PRODUCT_SUCCESS:
        return {
          ...state,
          loading: false,
          products: [...state.products, action.payload],
        };
      case CREATE_PRODUCT_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case UPDATE_PRODUCT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case UPDATE_PRODUCT_SUCCESS:
      
        return {
          ...state,
          loading: false,
          products: state.products.map((product) =>
            product.id === action.payload.id ? action.payload : product
          ),
        };
      case UPDATE_PRODUCT_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case DELETE_PRODUCT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case DELETE_PRODUCT_SUCCESS:
        console.log("dlete ",state.products)
        return {
          ...state,
          loading: false,
          deleteProduct:action.payload
          
          
        };
      case DELETE_PRODUCT_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };


            case SEARCH_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SEARCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchedProducts: action.payload,
      };

    case SEARCH_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        searchedProducts: [],
      };

    case GET_SIMILAR_PRODUCTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_SIMILAR_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        similarProducts: action.payload,
      };

    case GET_SIMILAR_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        similarProducts: [],
      };

    case GET_COMPLEMENTARY_PRODUCTS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_COMPLEMENTARY_PRODUCTS_SUCCESS:
      return { ...state, loading: false, complementaryProducts: action.payload };
    case GET_COMPLEMENTARY_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload, complementaryProducts: [] };

    case GET_COLOR_VARIANTS_REQUEST:
      return { ...state };
    case GET_COLOR_VARIANTS_SUCCESS:
      return { ...state, colorVariants: action.payload };
    case GET_COLOR_VARIANTS_FAILURE:
      return { ...state, colorVariants: [] };

    default:
      return state;
  }
};

export default customerProductReducer;
